import {
  Box,
  IconBlock,
  useTheme,
} from '@silverstein-properties/inspirelabs-ui';
import { useNavigate } from 'react-router-dom';

export interface SuccessProps {
  userName: string;
}

export function LoginSuccess(): JSX.Element {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box display="flex" justifyContent="center" marginTop={theme.spacers.xxl4}>
      <Box sx={{ width: { xs: '70vw', md: '35vw', lg: '25vw' } }}>
        <IconBlock
          icon="/images/success.svg"
          iconColor="success.main"
          iconSize={80}
          title="You're all set!"
          titleSize="h4"
          body="Your Two factor authentication was setup successfully"
          titleMarginBottom={theme.spacers.m_num}
          primaryButtonTitle="Get Started"
          onClickPrimaryButton={() => navigate('/dashboard')}
        />
      </Box>
    </Box>
  );
}
